<template>
   <page-wrapper>
      <form-wrapper broadWidth>
         <request-form/>
         <hr/>
         <go-to-link
            question="Go to log in page?"
            label="Log In"
            routeName="login"
         />
         <div style="margin-top: 25vh;"/>
      </form-wrapper>
   </page-wrapper>
</template>

<script>
import PageWrapper from '../../atoms/Login/PageWrapper';
import FormWrapper from '../../atoms/Login/FormWrapper';
import RequestForm from '../../organisms/RequestPasswordReset/RequestForm';
import GoToLink from '../../molecules/Login/GotoPageLink';

export default {
   name: 'RequestPasswordReset',
   components: {
      PageWrapper,
      FormWrapper,
      RequestForm,
      GoToLink,
   },
}
</script>

<style>

</style>